module.exports = __webpack_public_path__ + "static/media/product-feature-2.2773c6f8.svg";